// API
export const GET_PROMOTIONS_COUPONS_API =
	'/promotions/list?columns[12][search][value]=1';
export const FETCH_PROMOTION_API = '/promotions/:id';

// Queries
export const QUERY_PROMOTIONS_COUPONS_DATA = 'QUERY_PROMOTIONS_COUPONS_DATA';
